export const VENDOR = {
  SHELL: { ID: 117, IMAGEURL: '' },
  SMILES: { ID: 21185, IMAGEURL: '' },
  PAYBILLS: { ID: 21188, IMAGEURL: '' },
  DONATION: { ID: 54, IMAGEURL: '' },
  CELLPHONERECHARGE: { ID: 71, IMAGEURL: '' }
}

export const OPERATORS = {
  CLARO: { description: 'Claro', IMAGEURL: '' },
  NEXTEL: { description: 'Nextel', IMAGEURL: '' },
  OI: { description: 'Oi', IMAGEURL: '' },
  TIM: { description: 'Tim', IMAGEURL: '' },
  VIVO: { description: 'Vivo', IMAGEURL: '' }
}

export default {
  VENDOR,
  OPERATORS
}



// WEBPACK FOOTER //
// ./src/features/ProductImageDonation/constants.js